export enum EGroupsTags {
  ALL_GROUPS = 'allGroups',
  GROUPS = 'groups'
}

export type TAllGroupsParams = {
  district: string;
};

export type TFetchGroupsParams = {
  district: string;
  search?: string;
  page?: string;
};
